import {endpoints} from './endpoints'
import request from '../../request'

export function getUserSignature(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getUserSignature,
			method: 'get',
			params
		})
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function requestSignPin(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.requestSignPin,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function signWithPin(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.signWithPin,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}